// Global application-layer stack.
// Keep local intra-component stacking (for example focus rings or internal tab layers)
// next to the component that owns it; use these values when a surface can overlap
// unrelated page chrome such as nav, popovers, tooltips, or modals.
export enum ZIndex {
  // Sticky in-page content (table toolbars, section headers): above scrolling
  // page content, but BELOW every app-chrome layer — panels/sidebars
  // (NAVIGATION_OVERLAY) and everything higher must always cover it.
  STICKY_CONTENT = 30,
  NAVIGATION_CHROME = 40,
  NAVIGATION_OVERLAY = 45,
  PRODUCT_NUDGE = 46,
  FLOATING_TABLE_CELL = 48,
  MODAL = 50,
  POPOVER = 60,
  NAVIGATION_FLYOUT = 65,
  TOOLTIP = 70,
  COMMAND_PALETTE = 80,
  // Managed dialogs isolate their layers above page-owned floating content.
  OVERLAY_ROOT = 100,
  // Global notifications remain visible and actionable above every managed modal layer.
  GLOBAL_TOAST = 110,
}

export enum ZIndexClass {
  STICKY_CONTENT = "z-30",
  NAVIGATION_CHROME = "z-40",
  NAVIGATION_OVERLAY = "z-[45]",
  PRODUCT_NUDGE = "z-[46]",
  FLOATING_TABLE_CELL = "z-[48]",
  MODAL = "z-50",
  POPOVER = "z-[60]",
  NAVIGATION_FLYOUT = "z-[65]",
  TOOLTIP = "z-[70]",
  COMMAND_PALETTE = "z-[80]",
}
